import { AgResourceLanguage } from '../types';

export const shop: AgResourceLanguage['shop'] = {
  title: 'Bestellen',
  category: 'Category',
  allProducts: 'Alle Produkte',
  gifts: 'Geschenke',
  supplements: 'Supplements',
  subscriptions: 'Abonnements',
  accessories: 'Zubehör',
  gear: 'Merchandise',
  button: {
    addToCart: 'Zum Warenkorb hinzufügen',
    addToNextOrder: 'Zur nächsten Lieferung hinzufügen',
    subscribe: 'Abonnieren',
    addedToNextOrder: 'Zur nächsten Bestellung hinzugefügt'
  },
  singleSubscription: 'Einzel-Abo',
  doubleSubscription: 'Doppel-Abo',
  description30: '30 Portionen',
  description60: '60 Portionen, günstigstes Angebot',
  descriptionIndividual30: '30 Einzelportionen',
  scoopAvailabilityInfo:
    '*Verfügbar zum Hinzufügen zum Warenkorb, wenn mindestens ein anderes Produkt im Warenkorb ist',
  scoopPrompt: 'Brauchen Sie eine Schaufel für Ihre Tasche? Fügen Sie es unten kostenlos hinzu'
};
